var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$_selectedMerchant)?_c('tabs-page',{attrs:{"tabs":_vm.tabs,"keep-alive":false,"title":"Data Exports","show-single-tab":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }